module.exports = __webpack_public_path__ + "assets/img/proofread_2.2168312e.png";